<template>
    <v-card class="mx-auto">
        <v-card-title>Course in the Ward</v-card-title>
        <v-card-text>
            <v-form ref="form" lazy-validation>
                <v-row>
                    <v-col cols="12" md="2" sm="12">
                        <v-menu
                                v-model="dateAction"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                        v-model="computedDateFormatted"
                                        label="Date action"
                                        placeholder="YYYY-MM-DD"
                                        hint="YYYY-MM-DD Format"
                                        persistent-hint
                                        outlined
                                        readonly
                                        clearable
                                        v-on="on"
                                        :rules="[v => !!v || 'Date action is required']"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="course_ward.date_action" no-title @input="dateAction = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" md="9" sm="12">
                        <v-textarea
                                outlined
                                rows="1"
                                auto-grow
                                v-model="course_ward.doctor_action"
                                :rules="[v => !!v || 'Doctor Action is required']"
                                placeholder="Doctor Action"
                                label="Doctor Action"
                                required
                        />
                    </v-col>
                    <v-col cols="12" md="1" sm="12">
                        <v-btn @click="addRow" color="success" class="ma-2 float-md-right">
              <v-icon>mdi-plus</v-icon>
              Add
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
            <v-simple-table>
                            <thead>
                            <tr>
                                <th class="text-left">Date Action</th>
                                <th class="text-left">Doctor Action</th>
                                <th class="text-left">Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, index) in formData.course_ward" :key="index">
                                <td>{{ item.date_action }}</td>
                                <td>{{ item.doctor_action }}</td>
                                <td>
                  <v-btn @click="remove(index)"  x-small fab dark color="red">
                    <v-icon>mdi-window-close</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-form>


        </v-card-text>
        <v-card-actions>
      <v-spacer></v-spacer>

            <v-btn
                    :disabled="currentTab === 0"
                    @click="backTab"
                    color="info"
                    class="mr-4">
                BACK
            </v-btn>
            <v-btn
                    :disabled="!formData.course_ward.length"
                    @click="validate"
                    color="success"
                    class="mr-4">
                NEXT
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        name: "CourseWard",

        props: {
            currentTab: Number,
            formData: {
                required: true,
                type: Object
            }
        },

        data() {
            return {
                modal: false,
                menu: false,
                valid: false,
                dateAction: false,
                course_ward: {}
            }
        },

        computed: {
            computedDateFormatted: {
                get() {
                    return this.parseDate(this.course_ward.date_action);
                },
                set(value) {
                    this.course_ward.date_action = value;
                },
            },
        },

        watch: {
            date (val) {
                this.dateFormatted = this.formatDate(this.course_ward.date_action)
            },
        },

        methods: {
            validate() {
                if (this.formData.course_ward.length !== 0) {
                    this.$bus.emit('nextTab', this.currentTab + 1);
                }
            },
            reset() {
                this.$refs.form.reset()
            },
            backTab() {
                this.$bus.emit('nextTab', this.currentTab - 1);
            },

            addRow() {
                const course_ward = this.formData.course_ward;
                if (this.$refs.form.validate()) {
                    course_ward.push({
                        date_action: this.course_ward.date_action,
                        doctor_action: this.course_ward.doctor_action,
                    });
                    this.reset();
                    course_ward.sort(function(a, b) {
                        let dateA = new Date(a.date_action), dateB = new Date(b.date_action);
                        return dateA - dateB;
                    });
                }
            },

            remove(index) {
                this.formData.course_ward.splice(index, 1);
            },

            formatDate (date) {
                if (!date) return null;

                const [year, month, day] = date.split('-');
                return `${month}/${day}/${year}`
            },

            parseDate (date) {
                if (!date) return null;

                const [year, month, day] = date.split('-');
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
        },
    }
</script>

<style scoped>

</style>